import { Divider } from '@mui/material'
import styles from '../../pages/UserSettings.module.scss'

const TabHeader = ({header, msg}) => {
    return (
        <>
            <div className={styles['tab_header']}>
                <h3>{header}</h3>
                <div className={styles['msg']}>{msg}</div>
            </div>
            <Divider />
        </>
    )
}
export default TabHeader